/**
 * Offer Edit page module.
 * Refactored to use shared modules for cascading dropdowns and group visibility.
 */

import { setupCascadingDropdown } from '../lib/cascading-dropdown';
import { setupContactPersonDropdown } from '../lib/contact-dropdown';
import { applyGroupVisibility } from '../modules/offer/group-visibility';
import type { OfferTypeItem } from '../lib/types';

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('edit-offer-form') as HTMLFormElement | null;
    if (!form) return;

    const getUsersUrl = form.dataset.urlUsersForAgency || '';
    const offerTypes: OfferTypeItem[] = JSON.parse(form.dataset.offerTypes || '[]');

    const currentGroup = form.dataset.currentGroup || '';
    const currentOfferTypeId = form.dataset.currentOfferTypeId || '';
    const currentContactPersonId = form.dataset.currentContactPersonId || '';
    const currentAgencyId = form.dataset.currentAgencyId || '';

    const groupSelect = document.getElementById('OfferGroup') as HTMLSelectElement | null;
    const typeSelect = document.getElementById('OfferTypeId') as HTMLSelectElement | null;
    const agencySelect = document.getElementById('AgencyId') as HTMLSelectElement | null;

    if (!groupSelect || !typeSelect || !agencySelect) return;

    // Setup cascading Group → Type dropdown with pre-selection
    setupCascadingDropdown({
        groupSelect,
        typeSelect,
        offerTypes,
        currentGroup,
        currentTypeId: currentOfferTypeId,
        onGroupChange: (selectedGroup) => {
            applyGroupVisibility(selectedGroup, {
                transportSection: document.getElementById('transport-fields-section'),
                profileImageSection: document.getElementById('profile-image-section'),
                contactFieldsSection: document.getElementById('contact-fields-section')
            });
        }
    });

    // Apply initial visibility
    applyGroupVisibility(currentGroup, {
        transportSection: document.getElementById('transport-fields-section'),
        profileImageSection: document.getElementById('profile-image-section'),
        contactFieldsSection: document.getElementById('contact-fields-section')
    });

    // Setup Agency → Contact Person dropdown with pre-selection
    setupContactPersonDropdown({
        agencySelect,
        containerElementId: 'dependentDropdownContainer',
        getUsersUrl,
        preselectedContactId: currentContactPersonId,
        preselectedAgencyId: currentAgencyId
    });
});
